// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F7ah","questions":"styles_questions__KYhTv","footer":"styles_footer__1Z3Ot"};